// extracted by mini-css-extract-plugin
module.exports = {"line":"line-3LfR8","money":"money-3yPWh","label":"label-2JboF","line_min":"line_min-1GeP_","line_max":"line_max-3DrEg"};